"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterEventInformation = exports.filterPOCs = exports.filterMemberComments = exports.appropriatelyFilterPointsOfContact = exports.getAppropriateDebriefItems = exports.hasBasicAttendanceManagementPermission = exports.getCustomAttendanceFieldForValue = exports.applyCustomAttendanceFields = exports.defaultCustomAttendanceFieldValue = exports.effectiveManageEventPermissionForEvent = exports.effectiveManageEventPermission = exports.canMaybeFullyManageEvent = exports.canMaybeManageEvent = exports.canFullyManageEvent = exports.canManageEvent = exports.getAttendanceRecordForMember = exports.hasBasicEventPermissions = exports.hasMember = exports.getURIComponent = exports.canSignSomeoneElseUpForEvent = exports.canSignUpForEvent = exports.isPOCOf = void 0;
const ramda_1 = require("ramda");
const types_1 = require("../typings/types");
const Either_1 = require("./Either");
const Maybe_1 = require("./Maybe");
const Member_1 = require("./Member");
const Team_1 = require("./Team");
const Util_1 = require("./Util");
const isPOCOf = (member, event) => (member.type === 'CAPNHQMember' && (member.id === 546319 || member.id === 542488)) ||
    Member_1.areMembersTheSame(member)(event.author) ||
    event.pointsOfContact
        .map(poc => poc.type === types_1.PointOfContactType.INTERNAL &&
        Member_1.areMembersTheSame(member)(poc.memberReference))
        .reduce((prev, curr) => prev || curr, false);
exports.isPOCOf = isPOCOf;
const canSignUpForEvent = (event) => (eventTeam) => ramda_1.pipe(Either_1.Either.right, Either_1.Either.filterType((member) => !!member)('Cannot sign up without being signed in'), Either_1.Either.filter(Util_1.complement(exports.hasMember(event)))('Member is already in attendance'), Either_1.Either.filter(() => event.acceptSignups)(event.signUpDenyMessage || 'Sign ups are not allowed for this event'), Either_1.Either.filter(member => event.teamID === null ||
    event.teamID === undefined ||
    !event.limitSignupsToTeam ||
    Maybe_1.Maybe.orSome(false)(Maybe_1.Maybe.map(Team_1.isPartOfTeam(member))(eventTeam)))('Member is required to be a part of the team'), Either_1.Either.filter(() => event.registration === null ||
    event.registration === undefined ||
    event.registration.deadline > +new Date())('Cannot sign up for event after registration deadline'), Either_1.Either.map(Util_1.destroy));
exports.canSignUpForEvent = canSignUpForEvent;
const canSignSomeoneElseUpForEvent = (event) => ramda_1.pipe(Either_1.Either.right, Either_1.Either.filter(Util_1.complement(exports.hasMember(event)))('Member is already in attendance'), Either_1.Either.map(Util_1.destroy));
exports.canSignSomeoneElseUpForEvent = canSignSomeoneElseUpForEvent;
const getURIComponent = (event) => `${event.id}-${event.name.toLocaleLowerCase().replace(/ /g, '-')}`;
exports.getURIComponent = getURIComponent;
const hasMember = (event) => (member) => event.attendance.map(Util_1.get('memberID')).filter(Member_1.areMembersTheSame(member)).length > 0;
exports.hasMember = hasMember;
const DRAFT_EVENT_DUTY_POSITIONS = [
    'Cadet Operations Officer',
    'Cadet Operations NCO',
    'Cadet Activities Officer',
    'Cadet Activities NCO',
    'Cadet Emergency Services Officer',
    'Cadet Emergency Services NCO',
];
const FULL_MANAGE_EVENT_DUTY_POSITIONS = [
    'Cadet Commander',
    'Cadet Deputy Commander for Operations',
    'Cadet Deputy Commander for Support',
    'Commander',
    'Vice Commander',
    'Deputy Commander for Cadets',
    'Deputy Commander for Seniors',
    'Director of Cadet Programs',
    'Director of Emergency Services',
    'Operations Officer',
    'Activities Officer',
    'Squadron Activities Officer',
];
const hasBasicEventPermissions = (member) => Member_1.hasPermission('ManageEvent')(types_1.Permissions.ManageEvent.ADDDRAFTEVENTS)(member) ||
    Member_1.hasPermission('ManageEvent')(types_1.Permissions.ManageEvent.FULL)(member) ||
    ((member.type === 'CAPNHQMember' || member.type === 'CAPProspectiveMember') &&
        Member_1.hasOneDutyPosition([...DRAFT_EVENT_DUTY_POSITIONS, ...FULL_MANAGE_EVENT_DUTY_POSITIONS])(member));
exports.hasBasicEventPermissions = hasBasicEventPermissions;
const getAttendanceRecordForMember = (attendance) => (member) => attendance.find(val => Member_1.areMembersTheSame(member)(val.memberID));
exports.getAttendanceRecordForMember = getAttendanceRecordForMember;
const canManageEvent = (member) => (event) => exports.isPOCOf(member, event) ||
    [types_1.Permissions.ManageEvent.FULL, types_1.Permissions.ManageEvent.ADDDRAFTEVENTS].includes(exports.effectiveManageEventPermissionForEvent(member)(event));
exports.canManageEvent = canManageEvent;
const canFullyManageEvent = (member) => (event) => exports.isPOCOf(member, event) ||
    exports.effectiveManageEventPermissionForEvent(member)(event) === types_1.Permissions.ManageEvent.FULL;
exports.canFullyManageEvent = canFullyManageEvent;
const canMaybeManageEvent = (member) => (event) => (Maybe_1.Maybe.isSome(member) ? exports.canManageEvent(member.value)(event) : false);
exports.canMaybeManageEvent = canMaybeManageEvent;
const canMaybeFullyManageEvent = (member) => (event) => (Maybe_1.Maybe.isSome(member) ? exports.canFullyManageEvent(member.value)(event) : false);
exports.canMaybeFullyManageEvent = canMaybeFullyManageEvent;
const orderedManageEventPermissions = [
    types_1.Permissions.ManageEvent.NONE,
    types_1.Permissions.ManageEvent.ADDDRAFTEVENTS,
    types_1.Permissions.ManageEvent.FULL,
];
const permissionIndex = (perm) => orderedManageEventPermissions.indexOf(perm);
const effectiveManageEventPermission = (member) => orderedManageEventPermissions[Math.max((member.type === 'CAPNHQMember' || member.type === 'CAPProspectiveMember') &&
    Member_1.hasOneDutyPosition(FULL_MANAGE_EVENT_DUTY_POSITIONS)(member)
    ? 2
    : 0, (member.type === 'CAPNHQMember' || member.type === 'CAPProspectiveMember') &&
    Member_1.hasOneDutyPosition(DRAFT_EVENT_DUTY_POSITIONS)(member)
    ? 1
    : 0, permissionIndex(member.permissions.ManageEvent), Member_1.isRioux(member) ? 2 : 0)];
exports.effectiveManageEventPermission = effectiveManageEventPermission;
const effectiveManageEventPermissionForEvent = (member) => (event) => orderedManageEventPermissions[Math.max(permissionIndex(exports.effectiveManageEventPermission(member)), exports.isPOCOf(member, event) ? 2 : 0)];
exports.effectiveManageEventPermissionForEvent = effectiveManageEventPermissionForEvent;
const defaultCustomAttendanceFieldValue = (field) => ({
    title: field.title,
    ...(field.type === types_1.CustomAttendanceFieldEntryType.CHECKBOX
        ? { type: field.type, value: field.preFill }
        : field.type === types_1.CustomAttendanceFieldEntryType.DATE ||
            field.type === types_1.CustomAttendanceFieldEntryType.NUMBER
            ? { type: field.type, value: field.preFill }
            : field.type === types_1.CustomAttendanceFieldEntryType.FILE
                ? { type: field.type, value: [] }
                : field.type === types_1.CustomAttendanceFieldEntryType.QUAL
                    ? { type: field.type, value: field.preFill }
                    : { type: field.type, value: field.preFill }),
});
exports.defaultCustomAttendanceFieldValue = defaultCustomAttendanceFieldValue;
const applyCustomAttendanceFields = (eventFields) => (memberFields) => eventFields.map(customField => {
    var _a;
    return (_a = memberFields.find(({ title }) => title === customField.title)) !== null && _a !== void 0 ? _a : exports.defaultCustomAttendanceFieldValue(customField);
});
exports.applyCustomAttendanceFields = applyCustomAttendanceFields;
const getCustomAttendanceFieldForValue = (eventFields) => (field) => eventFields.find(value => value.title === field.title);
exports.getCustomAttendanceFieldForValue = getCustomAttendanceFieldForValue;
const hasBasicAttendanceManagementPermission = (member) => (event) => (team) => exports.effectiveManageEventPermissionForEvent(member)(event) === types_1.Permissions.ManageEvent.FULL ||
    (Member_1.isCAPMember(member) &&
        Member_1.hasDutyPositions([
            'Cadet Deputy Commander for Support',
            'Cadet Administrative Officer',
            'Cadet Administrative NCO',
        ])(member)) ||
    (Maybe_1.Maybe.isSome(team) &&
        team.value.id === event.teamID &&
        (event.type === types_1.EventType.REGULAR || event.targetAccountID === team.value.accountID) &&
        Team_1.isTeamLeader(member)(team.value));
exports.hasBasicAttendanceManagementPermission = hasBasicAttendanceManagementPermission;
const getAppropriateDebriefItems = (viewer) => (event) => ({
    ...event,
    debrief: Maybe_1.Maybe.isNone(viewer)
        ? []
        : exports.effectiveManageEventPermissionForEvent(viewer.value)(event) ===
            types_1.Permissions.ManageEvent.FULL
            ? event.debrief
            : event.debrief.filter(val => val.publicView || Member_1.areMembersTheSame(viewer.value)(val.memberRef)),
});
exports.getAppropriateDebriefItems = getAppropriateDebriefItems;
const appropriatelyFilterPointsOfContact = (viewer) => (event) => ({
    ...event,
    pointsOfContact: Maybe_1.Maybe.isNone(viewer)
        ? event.pointsOfContact.map(poc => ({
            ...poc,
            email: poc.publicDisplay ? poc.email : '',
            phone: poc.publicDisplay ? poc.phone : '',
            receiveEventUpdates: false,
            receiveRoster: false,
            receiveSignUpUpdates: false,
            receiveUpdates: false,
        }))
        : exports.effectiveManageEventPermissionForEvent(viewer.value)(event) ===
            types_1.Permissions.ManageEvent.FULL
            ? event.pointsOfContact
            : event.pointsOfContact.map(poc => ({
                ...poc,
                receiveEventUpdates: false,
                receiveRoster: false,
                receiveSignUpUpdates: false,
                receiveUpdates: false,
            })),
});
exports.appropriatelyFilterPointsOfContact = appropriatelyFilterPointsOfContact;
const filterMemberComments = (viewer) => (event) => ({
    ...event,
    memberComments: Maybe_1.Maybe.isSome(viewer) ? event.memberComments : '',
});
exports.filterMemberComments = filterMemberComments;
const filterPOCs = (viewer) => (event) => ({
    ...event,
    pointsOfContact: event.pointsOfContact.filter(poc => poc.publicDisplay || Maybe_1.Maybe.isSome(viewer)),
});
exports.filterPOCs = filterPOCs;
const filterEventInformation = (viewer) => ramda_1.pipe(exports.appropriatelyFilterPointsOfContact(viewer), exports.getAppropriateDebriefItems(viewer), exports.filterMemberComments(viewer), exports.filterPOCs(viewer));
exports.filterEventInformation = filterEventInformation;
//# sourceMappingURL=Events.js.map